// avstemming-general-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'ava.common.notCompared': 'Ikke sammenliknet',
  'ava.common.enterAmount': 'Skriv et beløp.',
  'ava.common.date': 'Dato',
  'ava.common.amount': 'Beløp',
  'ava.common.remove': 'Fjern',
  'ava.common.add': 'Legg til',
  'ava.common.account': 'Konto',
  'ava.common.status': 'Status',
  'ava.common.requestDocs': 'Be om dokumentasjon',
  'ava.common.close': 'Lukk',
  'ava.common.cancel': 'Avbryt',
  'ava.common.source': 'Kilde',
  'ava.common.type': 'Type',
  'ava.common.voucher': 'Bilag',
  'ava.common.description': 'Beskrivelse',
  'ava.common.fileNotFound': 'Fant ikke filen i lageret.',
  'ava.status.notChecked': 'Ikke kontrollert',
  'ava.status.ok': 'OK',
  'ava.status.deviation': 'Avvik',
  'ava.status.notRelevant': 'Ikke relevant',
  'ava.item.class.timing': 'Tidsavvik',
  'ava.item.class.missingVoucher': 'Manglende bilag',
  'ava.item.class.misposting': 'Feilføring',
  'ava.item.class.unidentified': 'Uidentifisert',
  'ava.item.class.other': 'Annet',
  'ava.item.action.none': 'Ingen',
  'ava.item.action.followUp': 'Følges opp neste periode',
  'ava.item.action.createAdjustment': 'Opprett korrigeringsbilag',
  'ava.item.action.requestDocs': 'Be klienten om dokumentasjon',
  'ava.account.bookedBalance': 'Bokført saldo',
  'ava.diff.externalBalance': 'Ekstern saldo',
  'ava.diff.notEntered': 'Ikke lagt inn',
  'ava.diff.preliminary': 'Foreløpig differanse',
  'ava.diff.explainedItems': 'Forklarte poster',
  'ava.diff.unexplained': 'Uforklart differanse',
  'ava.items.reasonRequired': 'Skriv hva posten skyldes. Uten begrunnelse teller den ikke som forklart.',
  'ava.items.title': 'Avstemmingsposter',
  'ava.items.colReason': 'Hva posten skyldes',
  'ava.items.colClassification': 'Klassifisering',
  'ava.items.colAction': 'Tiltak',
  'ava.items.missingReason': 'Mangler begrunnelse',
  'ava.items.followUpDue': 'Frist for oppfølging',
  'ava.items.voucherBasis': 'Grunnlag for bilag',
  'ava.items.markUnresolved': 'Merk uløst',
  'ava.items.markResolved': 'Marker løst',
  'ava.items.reasonPlaceholder': 'Hva skyldes posten?',
  'ava.account.backTo': 'Tilbake til {area}',
  'ava.account.basisChanged': 'Bokført saldo har endret seg etter at kontoen ble avstemt. Grunnlaget er ikke det samme lenger.',
  'ava.account.reconciledAgo': 'avstemt {when}',
  'ava.account.accountingData': 'Regnskapsdata',
  'ava.account.area': 'Fagområde',
  'ava.account.lastUpdated': 'Sist oppdatert',
  'ava.account.reconciledAgainst': 'Avstemt mot',
  'ava.account.bookedBalanceNote': 'Bokført saldo hentes fra saldobalansen appen regner ut. Endrer regnskapet seg, følger tallet etter.',
  'ava.account.externalBasis': 'Eksternt grunnlag',
  'ava.account.externalBalance': 'Ekstern saldo',
  'ava.account.externalBalanceOptional': 'Ekstern saldo (valgfri her)',
  'ava.account.externalBalancePlaceholder': 'F.eks. 124 500,00',
  'ava.account.externalBalanceNumber': 'Ekstern saldo må være et tall.',
  'ava.account.documentDate': 'Dokumentdato',
  'ava.account.source': 'Kilde',
  'ava.account.sourcePlaceholder': 'F.eks. kontoutskrift fra DNB, hentet 03.09',
  'ava.account.reference': 'Referanse',
  'ava.account.referencePlaceholder': 'F.eks. utskriftsnummer eller bilagsreferanse',
  'ava.account.docsLinkedOne': '{count} dokument er koblet til kontoen.',
  'ava.account.docsLinkedMany': '{count} dokumenter er koblet til kontoen.',
  'ava.account.docsNone': 'Ingen dokumenter er koblet til kontoen. Last opp i panelet til høyre, eller skriv et notat under.',
  'ava.account.documentNote': 'Tilleggsnotat til dokumentasjonen',
  'ava.account.documentNotePlaceholder': 'F.eks. «Kontoutskrift lastet ned 03.09»',
  'ava.account.differenceCalc': 'Differanseberegning',
  'ava.account.conclusion': 'Konklusjon',
  'ava.account.conclusionPlaceholder': 'Hva viser avstemmingen, og hva bygger konklusjonen på?',
  'ava.account.remainingRisk': 'Gjenstående risiko',
  'ava.account.remainingRiskPlaceholder': 'F.eks. ingen',
  'ava.account.followUp': 'Oppfølging neste periode',
  'ava.account.followUpPlaceholder': 'F.eks. følg opp uidentifisert innbetaling',
  'ava.account.statusChecked': 'Kontrollert',
  'ava.account.statusReconciled': 'Avstemt',
  'ava.area.counts': '{approved} av {total} avstemt · {deviations} avvik · {missing} mangler dokumentasjon',
  'ava.area.noExternalNeeded': 'krever ikke eksternt grunnlag',
  'ava.area.sendToControl': 'Send området til kontroll',
  'ava.area.noAccounts': 'Ingen kontoer er lagt til dette området ennå. Åpne en konto under «Øvrig balanse» og flytt den hit.',
  'ava.area.colBooked': 'Bokført',
  'ava.area.colExternal': 'Ekstern',
  'ava.area.colUnexplained': 'Uforklart',
  'ava.area.colDocumentation': 'Dokumentasjon',
  'ava.area.changedAfterReconciliation': 'Endret etter avstemming',
  'ava.area.attached': 'Vedlagt',
  'ava.area.missing': 'Mangler',
  'ava.ctx.guide.bank': 'Bokført saldo mot kontoutskriften per periodeslutt. Poster i banken som ikke er bokført, og bokførte poster som ikke er i banken, skal forklares.',
  'ava.ctx.guide.kundefordringer': 'Hovedbok mot kundereskontro. Åpne poster skal kunne spesifiseres per kunde, og gamle krav vurderes for tap.',
  'ava.ctx.guide.leverandorgjeld': 'Hovedbok mot leverandørreskontro. Mottatte fakturaer som ikke er bokført hører til i perioden de gjelder.',
  'ava.ctx.guide.payroll': 'Lønnskontoene mot lønnsjournalen og a-meldingen: skyldig lønn, feriepenger og påløpt arbeidsgiveravgift.',
  'ava.ctx.guide.mva': 'MVA-kontoene mot terminoppgaven for perioden. Grunnlag og avgift skal henge sammen, og oppgjørskontoen skal gå i null etter betaling.',
  'ava.ctx.guide.skatt': 'Skattetrekk, arbeidsgiveravgift og betalbar skatt mot a-meldingen og skatteetatens oppgjør. Skattetrekk skal stå på egen konto til det er betalt.',
  'ava.ctx.guide.assets': 'Balanseførte eiendeler mot anleggsregisteret: anskaffelser, avganger og periodens avskrivninger.',
  'ava.ctx.guide.lan': 'Lån mot låneoppgaven: inngående saldo, opptak, avdrag og påløpte renter skal gå opp mot utgående saldo.',
  'ava.ctx.guide.egenkapital': 'Egenkapitalen mot generalforsamlingens vedtak: årets resultat, utbytte og andre disposisjoner.',
  'ava.ctx.guide.other': 'Øvrige balansekontoer. Hver konto skal ha en spesifikasjon som viser hva saldoen består av.',
  'ava.ctx.guide.periodekontroll': 'Kontrollene som gjelder hele perioden: at alle bilag er bokført, at periodiseringer er gjort, og at rapportene henger sammen.',
  'ava.ctx.term': 'Termin',
  'ava.ctx.deadline': 'Frist {date}',
  'ava.ctx.outputVat': 'Utgående MVA',
  'ava.ctx.inputVat': 'Inngående MVA',
  'ava.ctx.refundable': 'Til gode',
  'ava.ctx.payable': 'Å betale',
  'ava.ctx.filed': 'Oppgaven er levert',
  'ava.ctx.notFiled': 'Oppgaven er ikke levert',
  'ava.ctx.activeAssets': 'Aktive eiendeler',
  'ava.ctx.inAssetRegister': 'I anleggsregisteret',
  'ava.ctx.soldThisYear': 'Solgt i år',
  'ava.ctx.writtenOffThisYear': 'Utrangert i år',
  'ava.ctx.statementsLoaded': 'Kontoutskrifter lastet inn',
  'ava.ctx.inBankView': 'I bankflaten',
  'ava.ctx.unmatchedLines': 'Banklinjer uten kobling',
  'ava.ctx.totalNotOnlyPeriod': 'Samlet, ikke bare denne perioden',
  'ava.ctx.unpaidInvoices': 'Ubetalte fakturaer',
  'ava.ctx.statusToday': 'Status per i dag, ikke per periodeslutt',
  'ava.ctx.outstandingAmount': 'Utestående beløp',
  'ava.ctx.title': 'Grunnlag fra regnskapet',
  'ava.ctx.footnote': 'Tallene er regnskapets egne, hentet fra flatene som eier dem. De er en hjelp til å finne igjen grunnlaget — ikke et eksternt grunnlag i seg selv, og de fylles derfor ikke inn som ekstern saldo.',
  'ava.ledger.age.d0to30': '0–30 dager',
  'ava.ledger.age.d31to60': '31–60 dager',
  'ava.ledger.age.d61to90': '61–90 dager',
  'ava.ledger.age.over90': 'Over 90 dager',
  'ava.ledger.age.noDate': 'Uten dato',
  'ava.ledger.title': 'Posteringer i perioden',
  'ava.ledger.allAccounts': 'Alle kontoer i området',
  'ava.ledger.onlyOld': 'Kun eldre enn 60 dager',
  'ava.ledger.colText': 'Tekst',
  'ava.ledger.colAge': 'Alder',
  'ava.ledger.noMatch': 'Ingen posteringer matcher filteret.',
  'ava.ledger.noLines': 'Ingen posteringer på områdets kontoer i denne perioden.',
  'ava.check.critical': 'Kritisk',
  'ava.check.reasonRequired': 'Begrunnelse kreves',
  'ava.check.reason': 'Begrunnelse',
  'ava.check.reasonPlaceholder': 'Hva er avviket, og hva gjøres med det?',
  'ava.check.defaultGroup': 'Kontrollpunkter',
  'ava.check.title': 'Faglig sjekkliste',
  'ava.check.titleReadOnly': 'Faglig sjekkliste (utførerens, skrivebeskyttet)',
  'ava.check.noItems': 'Ingen kontrollpunkter er definert for dette fagområdet.',
  'ava.check.progress': '{done} av {total} punkter vurdert. Programmet er byråets eget — det sier hva som skal være sett på, ikke hva som er lov.',
  'ava.check.assessedAgo': 'Vurdert {when}',
  'ava.saldo.descriptionRequired': 'Skriv hva posten er.',
  'ava.saldo.title': 'Saldospesifikasjon',
  'ava.saldo.intro': 'Hvilke poster saldoen består av. Summen skal stemme med hovedboken.',
  'ava.saldo.colCounterparty': 'Motpart',
  'ava.saldo.colFrom': 'Fra',
  'ava.saldo.colTo': 'Til',
  'ava.saldo.colDocument': 'Dokument',
  'ava.saldo.descriptionPlaceholder': 'Hva er posten?',
  'ava.saldo.docRefPlaceholder': 'Bilag/ref.',
  'ava.saldo.sum': 'Sum spesifikasjon',
  'ava.saldo.deviates': 'Avviker {amount} fra hovedbok',
  'ava.saldo.matchesLedger': 'Stemmer med hovedbok',
  'ava.rollforward.title': 'Rullerende avstemming',
  'ava.rollforward.warning': 'Utgående saldo henger ikke sammen med inngående saldo og periodens bevegelse. Det er saldobalansen som må ses på, ikke avstemmingen.',
  'ava.blocker.title': 'Kan ikke settes til avstemt ennå',
  'ava.blocker.note': 'Reglene håndheves i backend. Rett opp punktene over, så åpner statusen seg av seg selv.',
  'ava.adjust.description': 'Korrigering avstemming {account} {period}',
  'ava.adjust.copyDescription': 'Beskrivelse: {value}',
  'ava.adjust.copyAmount': 'Beløp: {value}',
  'ava.adjust.copyAccount': 'Konto: {value}',
  'ava.adjust.copyDirection': 'Retning: {value}',
  'ava.adjust.accountDown': 'Kontoen skal ned',
  'ava.adjust.accountUp': 'Kontoen skal opp',
  'ava.adjust.copied': 'Grunnlaget er kopiert. Lim det inn i en manuell postering.',
  'ava.adjust.copyFailed': 'Kunne ikke kopiere. Skriv av tallene over.',
  'ava.adjust.copyUnavailable': 'Kopiering er ikke tilgjengelig her. Skriv av tallene over.',
  'ava.adjust.title': 'Opprett korrigeringsbilag',
  'ava.adjust.copyBasis': 'Kopier grunnlaget',
  'ava.adjust.period': 'Periode',
  'ava.adjust.direction': 'Retning',
  'ava.adjust.note': 'Selve bilaget føres som en manuell postering i regnskapet, ikke her. Da får det samme validering, samme bilagsnummer og samme kontrollspor som alt annet som er bokført.',
  'ava.docs.kind.statement': 'Kontoutskrift',
  'ava.docs.kind.balanceConfirmation': 'Saldobekreftelse',
  'ava.docs.kind.subledgerList': 'Reskontroliste',
  'ava.docs.kind.aMelding': 'A-melding',
  'ava.docs.kind.vatReturn': 'Terminoppgave',
  'ava.docs.kind.agreement': 'Avtale',
  'ava.docs.kind.other': 'Annet',
  'ava.docs.req.waiting': 'Venter på svar',
  'ava.docs.req.answered': 'Besvart',
  'ava.docs.req.closed': 'Lukket',
  'ava.docs.loading': 'Henter dokumentet …',
  'ava.docs.unsupportedType': 'Denne filtypen kan ikke vises her.',
  'ava.docs.openInNewTab': 'Åpne i ny fane',
  'ava.docs.size': 'Størrelse',
  'ava.docs.fromClient': 'Fra klienten',
  'ava.docs.uploadedByFirm': 'Lastet opp av byrået',
  'ava.docs.uploadedBy': 'Lastet opp av',
  'ava.docs.time': 'Tidspunkt',
  'ava.docs.linkedTo': 'Koblet til',
  'ava.docs.wholePeriod': 'Hele perioden',
  'ava.docs.colUploaded': 'Lastet opp',
  'ava.docs.sourceClient': 'Klienten',
  'ava.docs.sourceFirm': 'Byrået',
  'ava.docs.viewDocument': 'Vis dokument',
  'ava.docs.noneForAccount': 'Ingen dokumenter koblet til denne kontoen.',
  'ava.docs.noneForPeriod': 'Ingen dokumenter lastet opp i denne perioden.',
  'ava.docs.preview': 'Forhåndsvis',
  'ava.docs.open': 'Åpne',
  'ava.docs.documentType': 'Dokumenttype',
  'ava.docs.upload': 'Last opp dokument',
  'ava.docs.noRequests': 'Ingen forespørsler sendt for denne perioden.',
  'ava.docs.dueDate': 'Svarfrist {date}',
  'ava.docs.noDueDate': 'Uten svarfrist',
  'ava.docs.sentBy': 'sendt av {email}',
  'ava.docs.documentsReceived': '{count} dokument mottatt',
  'ava.docs.markAnswered': 'Merk som besvart',
  'ava.docs.sendRequest': 'Send forespørsel',
  'ava.docs.concerns': 'Gjelder {account}',
  'ava.docs.subject': 'Emne',
  'ava.docs.subjectPlaceholder': 'F.eks. Kontoutskrift for august',
  'ava.docs.whatDoYouNeed': 'Hva trenger dere',
  'ava.docs.bodyPlaceholder': 'Beskriv hva som mangler, og hvorfor det trengs',
  'ava.docs.requestedDocumentation': 'Ønsket dokumentasjon',
  'ava.docs.requestedDocumentationPlaceholder': 'F.eks. kontoutskrift fra banken',
  'ava.docs.dueLabel': 'Svarfrist',
  'ava.docs.requestNote': 'Forespørselen legges i dialogen dere har med klienten, og blir stående her til den er besvart.',
  'ava.drawer.ariaLabel': 'Avstemming for {name}',
  'ava.drawer.org': 'Org. {org}',
  'ava.drawer.openFolder': 'Åpne hele avstemmingsmappa',
  'ava.drawer.responsible': 'Ansvarlig',
  'ava.drawer.deadline': 'Frist',
  'ava.drawer.progress': 'Fremdrift',
  'ava.drawer.locked': 'Perioden er låst. Gjenåpning krever en begrunnelse.',
  'ava.drawer.statusNote': 'Statusen per område utledes av kontoene under det. Den settes ikke her — et område kan ikke stå som avstemt mens en konto har en uforklart differanse.',
  'ava.drawer.filterTitle': 'Vis klienter med åpne punkter i',
  'ava.drawer.clearAll': 'Fjern alle',
});
